module.exports = __webpack_public_path__ + "media/images/games/world_culture_awareness/18-27fb30ae969a9e2e7d34344d76b65904.png";